import { AnnotationComponentProps } from "@pages/Article/components/StoryElements/Annotation/utils/types";

export default function AnnotationComponentStrikethrough({
  children,
}: AnnotationComponentProps): React.ReactElement {
  return <s>{children}</s>;
}
